import { useStyles } from '@webapps/styles';
import TutorialIcon from 'components/Icons/Tutorial';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

export default function Card({ icon, title, subtitle, onClick, value }) {
  const { classes } = useStyles(styles);

  const handleClick = () => {
    onClick(value);
  };

  return (
    <article className={classes.card} onClick={handleClick}>
      <div className={classes.mainContent}>
        {icon === 'tutorial' ? (
          <TutorialIcon className={classes.icon} />
        ) : (
          <img src={icon} alt="icon" className={classes.icon} />
        )}
        <span className={classes.title}>{title}</span>
        <span className={classes.subtitle}>{subtitle}</span>
      </div>

      <ArrowForwardIcon color='#152652' className={classes.ArrowForwardIcon} />
    </article>
  );
}

const styles = () => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    padding: '8px 20px 8px 8px',
    boxShadow: '0 3px 15px rgba(192, 217, 255, 0.6)', // #C0D9FF à 60%
    cursor: 'pointer',
    gap: '8px',
    transition: 'all 0.2s ease',
    // Effet hover
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 15px rgba(192, 217, 255, 0.8)',
    },
    // Effet focus (quand on navigue au clavier)
    '&:focus': {
      outline: '2px solid #0060F9',
      outlineOffset: '4px',
    },
  },

  mainContent: {
    display: 'flex',
    alignItems: 'center',
    // On aligne icône, titre et sous-titre sur la même ligne
    gap: '8px',
  },

  icon: {
    width: '30px',
    height: '30px',
    flexShrink: 0,
    color: '#152652',
  },

  title: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 600, // Semibold
    fontSize: '13.5px',
    lineHeight: '15px',
  },

  subtitle: {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400, // Regular
    fontSize: '13.5px',
    lineHeight: '14px',
    color: '#5D75A8',
  },

  ArrowForwardIcon: {
    width: '16px',
    height: '16px',
    flexShrink: 0,
  },
});
